module.exports = __webpack_public_path__ + "652e75d8b943b4cd27fb9034e776f5a7.jpg";